import cn from 'clsx';

import { useIsBelow } from '@/hooks/useScrollTriggers';
import { useListingPageComponentRefs } from '@/hooks/useListingPageComponentRefs';

import { ContactButtonsGroup } from '../ContactButtonsGroup/ContactButtonsGroup';

import styles from './StickyFooter.module.css';

type StickyFooterProps = {
  className?: string;
};

export const StickyFooter = ({ className }: StickyFooterProps) => {
  const { contactFormInputGridRef } = useListingPageComponentRefs();

  const isVisible = useIsBelow({ ref: contactFormInputGridRef });

  return (
    <div className={cn(styles.wrapper, className)} data-sticky-footer-visible={isVisible}>
      <ContactButtonsGroup
        buttonGroupClassName={styles.buttonsContainer}
        overlineClassName={styles.overline}
        testId="sticky-footer_primary_request-expose"
      />
    </div>
  );
};
